// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1X0VY","footer":"ModalError_footer__3XqHD"};